export enum CardRegistration {
  FORCE = 0,
  OPTIONAL = 1,
  IGNORE = 2,
}
